// extracted by mini-css-extract-plugin
export default {"badge":"BadgeDato_badge__uNNcU","supuesto":"BadgeDato_supuesto__L5U0S"};